/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_1Inputs */

const en_bot_never_1 = /** @type {(inputs: Bot_Never_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in, create accounts or use anyone's cookies.`)
};

const id_bot_never_1 = /** @type {(inputs: Bot_Never_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk (login), membuat akun, atau memakai cookie pengguna.`)
};

/**
* | output |
* | --- |
* | "Log in, create accounts or use anyone's cookies." |
*
* @param {Bot_Never_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_1 = /** @type {((inputs?: Bot_Never_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_1(inputs)
	return en_bot_never_1(inputs)
});